import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ContactList, CrmChat } from '../components/crm';
import { ContactListNavigationState } from '../types/contactNavigation';
import styles from './CrmPageLayout.module.css';

const ContactListPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const contactListState = (location.state as { contactListState?: ContactListNavigationState } | null)?.contactListState ?? null;
  const [refreshToken, setRefreshToken] = React.useState(0);

  if (!user) {
    return (
      <div className="login-message">
        <p>Please sign in to access your contacts</p>
      </div>
    );
  }

  return (
    <div className={styles.pageLayout}>
      <div className={styles.contentColumn}>
        <ContactList
          initialState={contactListState}
          refreshToken={refreshToken}
          onContactClick={(contact, navigationState) => navigate(`/contacts/${contact.id}`, {
            state: { contactListState: navigationState },
          })}
          onCreateClick={(navigationState) => navigate('/contacts/new', {
            state: { contactListState: navigationState },
          })}
        />
      </div>
      <CrmChat onDataChanged={() => setRefreshToken((current) => current + 1)} />
    </div>
  );
};

export default ContactListPage;
